export const insertObjProperty = (obj: Record<string, any>, key: string, value: any, index?: number) => {
  let tmp: Record<string, any> = {};
  let i = 0;

  if (!index) {
    return { ...obj, [key]: value };
  }

  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      if (i === index && key && value) {
        tmp[key] = value;
      }

      tmp[prop] = obj[prop];

      i++;
    }
  }

  return tmp;
};

export const updateArrayAtIndex = (array: any[], item: any, idx: number) => {
  return [...array.slice(0, idx), item, ...array.slice(idx + 1)];
};

export const insertArrayAtIndex = (array: any[], item: any, idx: number) => {
  console.log(idx);
  return [...array.slice(0, idx), item, ...array.slice(idx)];
};
